var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0591 3.76758C42.081 1.44576 47.0362 1.44576 51.0581 3.76758L77.5239 19.0469C81.5461 21.3691 84.0239 25.6612 84.0239 30.3057V60.8643C84.0239 65.5087 81.5461 69.8008 77.5239 72.123L51.0581 87.4023C47.0361 89.7242 42.081 89.7242 38.0591 87.4023L11.5933 72.123C7.57111 69.8008 5.09326 65.5087 5.09326 60.8643V30.3057C5.09328 25.6613 7.57109 21.3691 11.5933 19.0469L38.0591 3.76758Z",
    fill: "#F3F0FF",
    stroke: "#CFBFFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2475_17853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 78,
    height: 87
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5591 4.05565C42.6531 2.26935 46.465 2.26935 49.559 4.05565L78.024 20.4897C81.118 22.2761 83.024 25.5774 83.024 29.15V62.0181C83.024 65.5907 81.118 68.892 78.024 70.6783L49.559 87.1124C46.4651 88.8987 42.6531 88.8987 39.5591 87.1124L11.0941 70.6783C8.00011 68.892 6.0941 65.5907 6.0941 62.0181V29.15C6.0941 25.5774 8.00011 22.2761 11.0941 20.4897L39.5591 4.05565Z",
    fill: "#EDF2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2475_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2225 53.7915C16.2957 48.1411 19.1748 42.5497 24.3126 40.0222L41.1333 31.7472C42.1889 31.2279 43.31 30.8543 44.466 30.6366L71.6253 25.5219C78.4765 24.2316 85.1258 28.5755 86.6968 35.3678L93.1227 63.1507C94.5221 69.2013 91.4465 75.3968 85.7808 77.9401L46.9186 95.3852C41.597 97.774 35.3357 96.3257 31.6037 91.8426L23.7313 82.3858C22.2487 80.6047 21.2691 78.4597 20.8939 76.1729L17.2225 53.7915Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4212 81.6357C23.7265 83.2193 25.1797 84.3406 26.8399 84.4C26.8493 84.399 26.8587 84.398 26.8683 84.3971C26.9206 84.3924 26.9776 84.3893 27.0385 84.3891L27.5523 84.3343L27.563 84.3332L27.5736 84.3322L94.0348 78.082L82.5678 18.6017L13.824 31.8548L23.4212 81.6357ZM97.3255 78.1115C97.5973 79.5216 96.5003 80.8738 94.9677 81.0176L27.8203 87.3324L27.0502 87.4145L27.0241 87.4195L27.0041 87.4194L26.9002 87.4305L26.848 87.4185C23.6694 87.398 20.8428 85.3006 20.254 82.2463L10.5456 31.8886C10.2926 30.5761 11.2286 29.2917 12.6361 29.0204L82.6152 15.5291C84.0188 15.2585 85.3701 16.0983 85.6238 17.4143L97.3255 78.1115Z",
    fill: "#CFBFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2475_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.501 78.4219L24.1434 94.0212L101.769 81.8345L31.7363 74.292C29.7251 82.0496 24.0747 80.2776 21.501 78.4219Z",
    fill: "#B197FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.3836 43.7948L86.9463 30.191L84.6699 18.3831L14.1072 31.9869L16.3836 43.7948ZM90.3063 30.1278C90.5378 31.3287 89.569 32.5249 88.1436 32.7997L16.2421 46.6616C14.8162 46.9365 13.4725 46.186 13.241 44.9853L10.7473 32.0501C10.5158 30.8494 11.4841 29.6531 12.9101 29.3782L84.8115 15.5163C86.237 15.2415 87.581 15.9919 87.8125 17.1927L90.3063 30.1278Z",
    fill: "#CFBFFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4611 4.64605L16.8227 1.81827L19.8328 4.66743L12.8731 7.68527L10.4611 4.64605Z",
    fill: "#7950F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4506 3.25717L67.0253 3.07634L66.0397 1.6869L61.0919 1.90836L62.4506 3.25717Z",
    fill: "#FFEC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6122 5.66287L77.3996 10.7557L78.295 8.13114L75.5026 3.52642L74.6122 5.66287Z",
    fill: "#FFC9C9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2475_17853)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12991,
    y: 0.850466,
    width: 8.86825,
    height: 8.86833,
    rx: 4,
    transform: "matrix(0.99019 -0.139725 0.139723 0.990191 22.5177 43.9934)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6542 42.3344C34.9271 42.5443 35.0072 42.9552 34.8331 43.2522L30.3752 50.8576C30.2011 51.1547 29.8387 51.2253 29.5658 51.0155L26.0715 48.3287C25.7986 48.1188 25.7185 47.7079 25.8925 47.4109C26.0666 47.1139 26.429 47.0433 26.7019 47.2531L29.7021 49.5599L33.8448 42.4922C34.0189 42.1952 34.3812 42.1246 34.6542 42.3344Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5544 42.3216C33.8301 41.8515 34.4228 41.7362 34.855 42.068C35.2613 42.3805 35.3778 42.9772 35.1186 43.4195L30.661 51.0251C30.3853 51.4954 29.7927 51.6109 29.3605 51.2786L25.8659 48.5921C25.4596 48.2797 25.3431 47.6829 25.6022 47.2407C25.8779 46.7703 26.4715 46.6547 26.9037 46.987L29.6031 49.0629L33.5544 42.3216ZM34.4484 42.5978C34.3349 42.5105 34.2033 42.5368 34.1308 42.6604L29.9878 49.7275C29.9393 49.8101 29.8576 49.8681 29.7636 49.8864C29.6697 49.9046 29.5723 49.8818 29.4964 49.8235L26.4961 47.516C26.3826 47.429 26.2509 47.4551 26.1785 47.5786C26.0896 47.7304 26.134 47.955 26.2734 48.0622L29.7671 50.7498C29.8806 50.837 30.0123 50.8106 30.0848 50.6873L34.5424 43.0816C34.6312 42.9298 34.5878 42.7051 34.4484 42.5978Z",
    fill: "#F3F0FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2475_17853)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12991,
    y: 0.850466,
    width: 8.86825,
    height: 8.86833,
    rx: 4,
    transform: "matrix(0.99019 -0.139725 0.139723 0.990191 24.9562 59.5373)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0921 57.8784C37.3651 58.0882 37.4452 58.4991 37.2711 58.7961L32.8132 66.4016C32.6391 66.6986 32.2767 66.7693 32.0038 66.5594L28.5095 63.8726C28.2366 63.6628 28.1564 63.2519 28.3305 62.9549C28.5046 62.6579 28.867 62.5872 29.1399 62.7971L32.1401 65.1039L36.2828 58.0362C36.4568 57.7392 36.8192 57.6685 37.0921 57.8784Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9934 57.8675C36.2691 57.3972 36.8627 57.2816 37.2949 57.6138C37.7011 57.9262 37.8176 58.5231 37.5586 58.9652L33.1 66.571C32.8242 67.0411 32.2316 67.1568 31.7994 66.8245L28.3048 64.138C27.8987 63.8256 27.783 63.2286 28.0421 62.7865C28.3179 62.3163 28.9105 62.2006 29.3427 62.5329L32.0419 64.6078L35.9934 57.8675ZM36.8874 58.1437C36.7739 58.0566 36.6421 58.0818 36.5697 58.2053L32.4277 65.2733C32.3793 65.3558 32.2974 65.4137 32.2036 65.4322C32.1096 65.4505 32.0113 65.4278 31.9353 65.3694L28.9351 63.0619C28.8216 62.975 28.6908 63.001 28.6184 63.1243C28.5294 63.2761 28.5729 63.5008 28.7123 63.6081L32.2071 66.2956C32.3204 66.3823 32.4514 66.3563 32.5237 66.2332L36.9823 58.6274C37.0709 58.4756 37.0267 58.2509 36.8874 58.1437Z",
    fill: "#F3F0FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2475_17853)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.12991,
    y: 0.850466,
    width: 8.86825,
    height: 8.86833,
    rx: 4,
    transform: "matrix(0.99019 -0.139725 0.139723 0.990191 20.3351 27.4777)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4715 25.8188C32.7445 26.0286 32.8246 26.4395 32.6505 26.7365L28.1926 34.342C28.0185 34.639 27.6561 34.7097 27.3832 34.4998L23.8889 31.8131C23.616 31.6032 23.5358 31.1923 23.7099 30.8953C23.884 30.5983 24.2464 30.5276 24.5193 30.7375L27.5195 33.0443L31.6622 25.9766C31.8362 25.6796 32.1986 25.6089 32.4715 25.8188Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3723 25.8079C31.648 25.3377 32.2416 25.2221 32.6738 25.5542C33.08 25.8666 33.1964 26.4635 32.9375 26.9056L28.4789 34.5114C28.2032 34.9817 27.6106 35.0973 27.1783 34.765L23.6837 32.0785C23.2777 31.766 23.162 31.169 23.421 30.7269C23.6969 30.2568 24.2895 30.1411 24.7216 30.4734L27.4209 32.5492L31.3723 25.8079ZM32.2663 26.0841C32.1528 25.9971 32.0211 26.0232 31.9487 26.1467L27.8066 33.2137C27.7582 33.2962 27.6763 33.3542 27.5825 33.3726C27.4885 33.3909 27.3902 33.3682 27.3142 33.3098L24.3141 31.0033C24.2006 30.916 24.0688 30.9414 23.9964 31.0649C23.9076 31.2167 23.9519 31.4413 24.0912 31.5486L27.586 34.236C27.6994 34.3229 27.8303 34.2969 27.9026 34.1736L32.3613 26.5688C32.4503 26.417 32.4058 26.1914 32.2663 26.0841Z",
    fill: "#F3F0FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6621 26.7383C42.6621 24.767 44.2602 23.1689 46.2314 23.1689H56.9395C58.8327 23.1689 60.6485 23.9211 61.9873 25.2598C63.326 26.5986 64.0781 28.4143 64.0781 30.3076V37.4463C64.0781 39.3396 63.326 41.1553 61.9873 42.4941C60.6485 43.8329 58.8327 44.585 56.9395 44.585H49.8008V51.7236H60.5088C62.4801 51.7236 64.0781 53.3217 64.0781 55.293C64.0781 57.2643 62.4801 58.8623 60.5088 58.8623H49.8008C47.9075 58.8623 46.0917 58.1102 44.753 56.7714C43.4142 55.4327 42.6621 53.6169 42.6621 51.7236V44.585C42.6621 42.6917 43.4142 40.8759 44.753 39.5372C46.0917 38.1984 47.9075 37.4463 49.8008 37.4463H56.9395V30.3076H46.2314C44.2602 30.3076 42.6621 28.7096 42.6621 26.7383Z",
    fill: "#212529"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6621 26.7383C42.6621 24.767 44.2602 23.1689 46.2314 23.1689H56.9395C58.8327 23.1689 60.6485 23.9211 61.9873 25.2598C63.326 26.5986 64.0781 28.4143 64.0781 30.3076V37.4463C64.0781 39.3396 63.326 41.1553 61.9873 42.4941C60.6485 43.8329 58.8327 44.585 56.9395 44.585H49.8008V51.7236H60.5088C62.4801 51.7236 64.0781 53.3217 64.0781 55.293C64.0781 57.2643 62.4801 58.8623 60.5088 58.8623H49.8008C47.9075 58.8623 46.0917 58.1102 44.753 56.7714C43.4142 55.4327 42.6621 53.6169 42.6621 51.7236V44.585C42.6621 42.6917 43.4142 40.8759 44.753 39.5372C46.0917 38.1984 47.9075 37.4463 49.8008 37.4463H56.9395V30.3076H46.2314C44.2602 30.3076 42.6621 28.7096 42.6621 26.7383Z",
    fill: "#7950F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1685 18.4457L54.5361 14.4661L56.5258 11.2822L63.689 15.6597L61.1685 18.4457Z",
    fill: "#FFC9C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.597 42.4199L81.4008 38.1225L83.2209 35.0418L88.8282 39.7622L86.597 42.4199Z",
    fill: "#99E9F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7791 22.4684L18.7858 19.7029L20.1494 17.7628L24.5539 18.3448L22.7791 22.4684Z",
    fill: "#99E9F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84494 36.9018L5.40418 32.3881L6.60661 34.7877L1.63593 39.6437L0.84494 36.9018Z",
    fill: "#99E9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 75.6278L15.4863 72.4177L16.2661 74.0793L12.8595 77.5336L12.3609 75.6278Z",
    fill: "#7950F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6398 20.9205L69.5404 18.0258L70.9404 19.9397L66.681 23.0471L65.6398 20.9205Z",
    fill: "#7950F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.664 3.43507L31.9706 5.92011L33.0636 9.75582L27.2837 6.9889L26.664 3.43507Z",
    fill: "#99E9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2652 20.0493L27.6372 17.4259L26.3256 15.3271L21.6037 18.2128L23.2652 20.0493Z",
    fill: "#FFEC99"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3588 3.11948L66.9335 2.93864L65.9479 1.5492L61.0001 1.77067L62.3588 3.11948Z",
    fill: "#FFEC99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6421 13.8303L66.8855 14.9302L67.7578 13.3226L64.2215 12.1577L63.6421 13.8303Z",
    fill: "#FFEC99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3646 75.2004L47.5149 76.8038L48.9739 74.2428L43.3571 72.5488L42.3646 75.2004Z",
    fill: "#FFEC99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58101 11.5699L16.2134 7.5903L15.0682 5.84668L8.4882 9.81384L9.58101 11.5699Z",
    fill: "#FFC9C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5204 5.52517L77.3078 10.618L78.2032 7.99344L75.4108 3.38872L74.5204 5.52517Z",
    fill: "#FFC9C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7857 80.932L80.7353 81.5557L79.6719 79.4404L75.0231 79.0859L75.7857 80.932Z",
    fill: "#FFC9C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0659 36.1387L20.6982 33.6073L18.7085 31.582L11.5454 34.3665L14.0659 36.1387Z",
    fill: "#FFC9C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2475_17853",
    x: 7.90098,
    y: 68.692,
    width: 93.8686,
    height: 30.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.677775 0 0 0 0 0.599488 0 0 0 0 0.903602 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2475_17853",
    x: 16.2744,
    y: 37.8779,
    width: 19.9819,
    height: 20.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2475_17853",
    x: 18.7129,
    y: 53.4238,
    width: 19.9834,
    height: 20.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2475_17853",
    x: 14.0918,
    y: 21.3643,
    width: 19.9834,
    height: 20.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17853",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1c4f73ca309bc56e36dd5e2e17dd4718.svg";
export { ForwardRef as ReactComponent };